import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCode, FaRocket, FaLaptopCode } from 'react-icons/fa';
import axios from 'axios';
import './Home.css';

function Home() {
  const [portfolio, setPortfolio] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const response = await axios.get('/api/portfolio');
        setPortfolio(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching portfolio:', error);
        setLoading(false);
      }
    };

    fetchPortfolio();
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Hi, I'm {portfolio?.name}</h1>
            <p className="hero-subtitle">{portfolio?.title}</p>
            <p className="hero-description">
              {portfolio?.bio}
            </p>
            <div className="hero-buttons">
              <Link to="/projects" className="btn btn-primary">
                View My Work
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Get In Touch
              </Link>
            </div>
          </div>
          <div className="hero-image">
            <div className="avatar-placeholder">
              <FaCode />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section section-light">
        <div className="container">
          <h2>What I Do</h2>
          <div className="grid grid-3">
            <div className="card feature-card">
              <div className="feature-icon">
                <FaLaptopCode />
              </div>
              <h3>Web Development</h3>
              <p>Building responsive and interactive web applications using modern technologies like React and Node.js</p>
            </div>

            <div className="card feature-card">
              <div className="feature-icon">
                <FaRocket />
              </div>
              <h3>Full Stack Development</h3>
              <p>Creating complete web solutions from frontend design to backend architecture with seamless integration</p>
            </div>

            <div className="card feature-card">
              <div className="feature-icon">
                <FaCode />
              </div>
              <h3>Problem Solving</h3>
              <p>Analyzing complex problems and implementing efficient, scalable solutions with clean code practices</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Next Project?</h2>
            <p>Let's work together to bring your ideas to life</p>
            <Link to="/contact" className="btn btn-primary">
              Contact Me Today
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;